import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["payment.loadingBillingNotes"],
  loading => loading
);
